import * as React from 'react'
import { CreditInfo } from '../api/models/credit';
import { CreditManager } from '../manager/creditmanager';

const context = React.createContext<CreditInfo>(CreditManager.instance().info)
export const CreditContextProvider = context.Provider
export const CreditContextConsumer = context.Consumer
export const CreditContext = context